import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, NgModule } from '@angular/core';
import { TranslatePipeModule } from '../../shared/translate.pipe';
import { ReferralPageBannerService } from './referral-page-banner.service';

@Component({
  selector: 'lp2-referral-page-banner',
  templateUrl: './referral-page-banner.component.html',
  styleUrls: ['./referral-page-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReferralPageBannerComponent {
  @Input() displayCloseButton? = true;
  referralBonusAmount$ = this.referralPageBannerService.localizedBonusAmount$;

  constructor(private referralPageBannerService: ReferralPageBannerService) {}

  dismissBanner() {
    this.referralPageBannerService.dismissBanner();
  }

  redirectToReferral() {
    this.referralPageBannerService.redirectToReferral();
  }
}

@NgModule({
  imports: [CommonModule, TranslatePipeModule],
  declarations: [ReferralPageBannerComponent],
  exports: [ReferralPageBannerComponent],
  providers: [ReferralPageBannerService],
})
export class ReferralPageBannerModule {}



// WEBPACK FOOTER //
// ./ts/app/home/referral-page-banner/referral-page-banner.component.ts